module.exports = __webpack_public_path__ + "img/ico-check-mark.d0297a71.svg";